import script from "./StudentAffairsStaticsticsIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentAffairsStaticsticsIndex.vue?vue&type=script&setup=true&lang=js"

import "./StudentAffairsStaticsticsIndex.vue?vue&type=style&index=0&id=7700277c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7700277c"]])

export default __exports__